import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  type ButtonProps,
} from '@mui/material';
import { type ReactNode } from 'react';

export interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void | Promise<void>;
  title?: ReactNode;
  children?: ReactNode;

  // optional labels
  cancelText?: string;
  confirmText?: string;

  // optional button props passthroughs
  cancelButtonProps?: ButtonProps;
  confirmButtonProps?: ButtonProps;
}

const CustomDialog = ({
  open,
  onClose,
  onSubmit,
  title,
  children,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  cancelButtonProps,
  confirmButtonProps,
}: CustomDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    sx={{
      '& .MuiDialog-paper': {
        minWidth: 300,
        maxWidth: '90vw',
        maxHeight: '90vh',
        width: 'auto',
        height: 'auto',
        border: '1px solid',
        borderColor: 'divider',
      },
    }}
  >
    {title && (
      <DialogTitle
        sx={{ pb: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Typography component="div" variant="h3">
          {title}
        </Typography>
      </DialogTitle>
    )}

    {children && (
      <DialogContent sx={{ pt: 2.5 }}>
        <Stack direction="column" spacing={2}>
          {children}
        </Stack>
      </DialogContent>
    )}

    <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
      <Button onClick={onClose} {...cancelButtonProps}>
        {cancelText}
      </Button>
      <Button onClick={onSubmit} variant="contained" {...confirmButtonProps}>
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CustomDialog;
